<template>
  <div v-if="isVisible" class="paywall-modal-overlay" @click.self="handleClose">
    <div class="paywall-modal variant-b">
      <button @click="handleClose" class="close-button">
        <i class="fa-solid fa-times"></i>
      </button>

      <!-- Central Visual Element -->
      <div class="central-visual">
        <div class="icon-ring">
          <div class="central-icon">
            <i class="fa-solid fa-brain"></i>
          </div>
          <div class="surrounding-icons">
            <div class="icon-item" v-for="(icon, index) in surroundingIcons" :key="index" :style="{ '--angle': (index * 360 / surroundingIcons.length) + 'deg' }">
              <i :class="icon"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Header -->
      <div class="paywall-header">
        <h2 class="paywall-title">روبو همیشه در کنار تو</h2>
        <p class="paywall-subtitle">
         «با نسخه حرفه‌ای روبو، بدون محدودیت از چت و تصویر و ویدیو استفاده کن. پاسخ‌های سریع‌تر و دقیق‌تر، فقط با روزی کمتر از 10 هزار تومان!»
        </p>
      </div>

      <!-- Progress Bar -->
      <!-- <div class="progress-section">
        <div class="progress-bar-container">
          <div class="progress-bar-fill" :style="{ width: progressPercentage + '%' }"></div>
        </div>
        <span class="progress-text">🔋 {{ remainingCookies }} از {{ totalCookies }} کوکی باقی مانده</span>
      </div> -->

      <!-- Benefits -->
      <div class="benefits-section">
        <div class="benefit-item">
          <i class="fa-solid fa-check-circle"></i>
          <span>چت، تصویر و ویدیو بدون محدودیت روزانه</span>
        </div>
        <div class="benefit-item">
          <i class="fa-solid fa-bolt"></i>
          <span>پاسخ‌های سریع‌تر و دقیق‌تر</span>
        </div>
        <div class="benefit-item">
          <i class="fa-solid fa-star"></i>
          <span>استفاده از جدیدترین مدل‌های هوش مصنوعی</span>
        </div>
      </div>

      <!-- Plan Selection - Two Cards Side by Side -->
      <div class="plan-section">
        <div class="plans-container">
          <!-- Plan 1: 1 Month Unlimited -->
          <div 
            :class="['plan-card', { 'selected': selectedPlan === 1 }]"
            @click="selectPlan(1)">
            <div v-if="selectedPlan === 1" class="selected-checkmark">
              <i class="fa-solid fa-check-circle"></i>
            </div>
            <div class="plan-period-number">1 ماهه</div>
            <div class="plan-unlimited">استفاده نامحدود</div>
            <div class="plan-pricing">
                <div class="price-monthly">{{ (package2Prices[1]/1000).toLocaleString() }} هزار تومان ماهانه</div>
            </div>
          </div>

          <!-- Plan 2: 12 Months with 50% Discount -->
          <div 
            :class="['plan-card', 'featured', { 'selected': selectedPlan === 2 }]"
            @click="selectPlan(2)">
            <div class="plan-badge">
              <i class="fa-solid fa-fire"></i>
              بهترین پیشنهاد
            </div>
            <div v-if="selectedPlan === 2" class="selected-checkmark">
              <i class="fa-solid fa-check-circle"></i>
            </div>
            <div class="plan-period-number">12 ماهه</div>
            <div class="plan-unlimited">استفاده نامحدود</div>
            <div class="plan-pricing">
              <div class="discount-badge">۵۰٪ صرفه جویی 🔥</div>
                <!-- <div class="price-monthly">{{ ((package2Prices[12] / 12)/1000).toLocaleString() }} هزار تومان ماهانه</div> -->
                <div class="price-monthly">{{ ((package2Prices[12])).toLocaleString() }} تومان سالیانه</div>

            </div>
          </div>
        </div>
        
        <!-- View All Button -->
        <button @click="viewAllPlans" class="view-all-button">
          <i class="fa-solid fa-list"></i>
          مشاهده همه بسته ها
        </button>
        <button @click="handleCheckout" class="cta-button variant-b-cta">
           ادامه بده و حرفه‌ ای شو 🚀
      </button>

      <!-- Trust Line -->
      <p class="trust-line">پرداخت امن | پشتیبانی سریع</p>
      <br/>
      </div>

      <!-- CTA Button -->
     
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import router from '@/router';

export default {
  name: 'PaywallVariantB',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    userCredit: {
      type: Number,
      default: 0
    },
    totalCookies: {
      type: Number,
      default: 10
    },
    triggerSource: {
      type: String,
      default: 'Chat'
    },
    referrer: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedPlan: 1, // 1 = 1 month, 2 = 12 months
      package2Prices: { 1: 598000, 12: 4500000 },
      isProcessing: false,
      sessionId: null,
      surroundingIcons: [
        'fa-solid fa-file-alt',
        'fa-solid fa-comments',
        'fa-solid fa-paint-brush',
        'fa-solid fa-chart-line',
        'fa-solid fa-music',
        'fa-solid fa-image',
        'fa-solid fa-video',
        'fa-solid fa-code'
      ]
    };
  },
  computed: {
    remainingCookies() {
      return this.userCredit;
    },
    progressPercentage() {
      return (this.remainingCookies / this.totalCookies) * 100;
    },
    selectedPlanData() {
      if (this.selectedPlan === 1) {
        return { package: 2, period: 1, price: this.package2Prices[1] / 1 };
      } else {
        return { package: 2, period: 12, price: this.package2Prices[12] / 12 };
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    selectPlan(planId) {
      this.selectedPlan = planId;
      this.logPaywallEvent('plan_select', planId);
    },
    async viewAllPlans() {
      await this.logPaywallEvent('view_all_packages', this.selectedPlan);
      this.$emit('close');
      router.push('/packages');
    },
    async handleCheckout() {
      
      await this.logPaywallEvent('click_cta', this.selectedPlan);
      
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          router.push('/login');
          return;
        }

        const isApplication = navigator.userAgent.match(/ir.roboo.pwa/i);
        const period = this.selectedPlan === 1 ? 1 : 12;
        const price = this.selectedPlan === 1 ? this.package2Prices[1] : (this.package2Prices[12] / 12);
        
        await this.logPaywallEvent('payment_start', this.selectedPlan, price);
        
        if (isApplication) {
          const planId = this.selectedPlan === 1 ? 'plan-2' : 'plan-2-12';
          // eslint-disable-next-line
          Android.kharid(planId);
          this.$emit('close');
        } else {
          const response = await axios.post(
            'https://api.roboo.ir/api/Payment/MakePayment',
            null,
            {
              params: {
                Token: token,
                Package: 2,
                Period: period,
                DiscountCode: ''
              }
            }
          );

          if (response.data && response.data) {
            window.location.href = response.data;
          }
        }
      } catch (error) {
        console.error('Payment error:', error);
      }
    },
    getDevice() {
      const ua = navigator.userAgent;
      const isApplication = ua.match(/ir.roboo.pwa/i);
      if (isApplication && /Android/i.test(ua)) return 'AndroidApp';
      if (/Android/i.test(ua)) return 'Android';
      if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
      return 'Web';
    },
    async logPaywallEvent(eventType, planId = null, price = null) {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        if (!this.sessionId) {
          this.sessionId = this.generateSessionId();
        }

        const period = planId === 1 ? 1 : (planId === 2 ? 12 : null);
        const actualPrice = price || (planId === 1 ? this.package2Prices[1] : (planId === 2 ? this.package2Prices[12] : null));

        await axios.post('https://api.roboo.ir/api/PaywallEventLogs/LogEvent', {
          Token: token,
          EventType: eventType,
          Variant: 'B',
          PlanId: planId ? 2 : null,
          Period: period,
          Price: actualPrice,
          DiscountPercent: null,
          TriggerSource: this.triggerSource || 'Chat',
          Device: this.getDevice(),
          SessionId: this.sessionId,
          Referrer: this.referrer || document.referrer || null
        });
      } catch (error) {
        console.error('Error logging paywall event:', error);
      }
    },
    generateSessionId() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  },
  mounted() {
    this.sessionId = this.generateSessionId();
    if (this.isVisible) {
      this.logPaywallEvent('view');
    }
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        if (!this.sessionId) {
          this.sessionId = this.generateSessionId();
        }
        this.logPaywallEvent('view');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.paywall-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;

}

.paywall-modal {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 40px;
  width: 100%;
  height: 100%;
  position: relative;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(97, 83, 204, 0.3);
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  scrollbar-width: none;  /* Firefox, Safari 18.2+, Chromium 121+ */
}

.close-button {
  position: absolute;
  top: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-size: 18px;
  z-index: 10;

  &:hover {
    background: rgba(97, 83, 204, 0.5);
    transform: rotate(90deg);
  }
}

.central-visual {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0 5px;
  flex-shrink: 0;
}
.icon-ring {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.central-icon {
  position: absolute;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #6153cc 0%, #7d70e2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 40px rgba(97, 83, 204, 0.6);
  z-index: 2;
  animation: pulse-glow 2s infinite;

  i {
    font-size: 36px;
    color: white;
  }
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 0 40px rgba(97, 83, 204, 0.6);
  }
  50% {
    box-shadow: 0 0 60px rgba(97, 83, 204, 0.9);
  }
}

.surrounding-icons {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.icon-item {
  position: absolute;
  width: 40px;
  height: 40px;
  background: rgba(97, 83, 204, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(var(--angle)) translateY(-90px) rotate(calc(-1 * var(--angle)));
  border: 2px solid rgba(97, 83, 204, 0.4);

  i {
    font-size: 18px;
    color: #6153cc;
  }
}


.paywall-header {
  text-align: center;
  flex-shrink: 0;
}

.header-icon {
  font-size: 56px;
  margin-bottom: 12px;
}

.paywall-title {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  margin: 12px 0;
  line-height: 1.4;
  font-family: IRANSansWeb;
}

.paywall-subtitle {
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  line-height: 1.6;
  margin-top: 8px;
  font-family: IRANSansWeb;
}

.progress-section {
  margin: 15px 0;
  background: rgba(97, 83, 204, 0.1);
  padding: 12px;
  border-radius: 12px;
  border: 1px solid rgba(97, 83, 204, 0.2);
  flex-shrink: 0;
}

.progress-bar-container {
  width: 100%;
  height: 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 12px;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #6153cc 0%, #7d70e2 100%);
  border-radius: 10px;
  transition: width 0.3s ease;
}

.progress-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-family: IRANSansWeb;
}

.benefits-section {
  margin: 0px 0 15px 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex-shrink: 0;
}

.benefit-item {
  display: flex;
  align-items: center;
  color: white;
  font-family: IRANSansWeb;

  i {
    color: #6153cc;
    margin-left: 12px;
    font-size: 18px;
  }

  span {
    font-size: 15px;
    line-height: 1.5;
  }
}

.plan-section {
  margin: 15px 0;
  flex: 1;
  min-height: 0;
}

.plans-container {
    display: flex;
    grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 15px;
}

.plan-card {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 20px 16px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 3px solid rgba(97, 83, 204, 0.4);
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &:hover {
    transform: translateY(-3px);
    border-color: rgba(97, 83, 204, 0.6);
    box-shadow: 0 8px 24px rgba(97, 83, 204, 0.3);
  }

  &.selected {
    border-color: #6153cc;
    border-width: 4px;
    background: rgba(97, 83, 204, 0.25);
    box-shadow: 0 10px 30px rgba(97, 83, 204, 0.6), 0 0 0 2px rgba(97, 83, 204, 0.3);
    transform: scale(1.02);
  }

  &.featured {
    border-color: #6153cc;
    background: linear-gradient(180deg, rgba(97, 83, 204, 0.35) 0%, rgba(97, 83, 204, 0.08) 50%, rgba(255, 255, 255, 0.08) 100%);
  }
}

.selected-checkmark {
  position: absolute;
  top: 12px;
  left: 12px;
  background: linear-gradient(135deg, #6153cc 0%, #7d70e2 100%);
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(97, 83, 204, 0.6);
  z-index: 4;
  animation: checkmark-appear 0.3s ease;

  i {
    font-size: 18px;
  }
}

@keyframes checkmark-appear {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.plan-badge {
  position: absolute;
  top: -14px;
  right: 50%;
  transform: translateX(50%);
  background: linear-gradient(135deg, #6153cc 0%, #7d70e2 100%);
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: bold;
  font-family: IRANSansWeb;
  box-shadow: 0 4px 12px rgba(97, 83, 204, 0.5);
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  z-index: 3;

  i {
    font-size: 14px;
  }
}

.discount-badge {
  top: 10px;
  right: 10px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: white;
  padding: 6px 14px;
  margin-bottom: 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: bold;
  font-family: IRANSansWeb;
  box-shadow: 0 3px 10px rgba(255, 107, 107, 0.5);
  z-index: 2;
  white-space: nowrap;
  animation: pulse-discount 2s infinite;
}

@keyframes pulse-discount {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 3px 10px rgba(255, 107, 107, 0.5);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.7);
  }
}

.plan-period-number {
  font-size: 26px;
  font-weight: bold;
  color: #6153cc;
  line-height: 1;
  margin: 12px 0 6px 0;
  font-family: IRANSansWeb;
}

.plan-period-text {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 8px;
  font-family: IRANSansWeb;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.plan-unlimited {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 12px;
  font-family: IRANSansWeb;
  font-weight: 500;
}

.plan-pricing {
  text-align: center;
  width: 100%;
  margin-top: auto;
}

.price-monthly {
  font-size: 18px;
  font-weight: bold;
  color: #6153cc;
  margin-bottom: 6px;
  font-family: IRANSansWeb;
}

.price-total {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 6px;
  font-family: IRANSansWeb;
}

.price-daily {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  font-family: IRANSansWeb;
}

.view-all-button {
  width: 100%;
  padding: 12px;
  background: rgba(97, 83, 204, 0.2);
  border: 1px solid rgba(97, 83, 204, 0.4);
  border-radius: 12px;
  color: white;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: IRANSansWeb;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  i {
    font-size: 14px;
  }

  &:hover {
    background: rgba(97, 83, 204, 0.3);
    border-color: #6153cc;
  }
}

.cta-button {
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 14px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: IRANSansWeb;
  margin-top: 15px;
  flex-shrink: 0;
}

.variant-b-cta {
  background: linear-gradient(135deg, #6153cc 0%, #7d70e2 100%);
  color: white;
  box-shadow: 0 10px 30px rgba(97, 83, 204, 0.5);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 15px 40px rgba(97, 83, 204, 0.7);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.trust-line {
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  margin-top: 15px;
  font-family: IRANSansWeb;
}

@media (max-width: 768px) {
  .paywall-modal {
    padding: 30px 20px;
  }

  .plans-container {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .paywall-title {
    font-size: 20px;
  }

  .paywall-subtitle {
    font-size: 14px;
  }

  .icon-ring {
    width: 160px;
    height: 160px;
  }

  .central-icon {
    width: 60px;
    height: 60px;

    i {
      font-size: 28px;
    }
  }

  .icon-item {
    width: 32px;
    height: 32px;
    transform: translate(-50%, -50%) rotate(var(--angle)) translateY(-70px) rotate(calc(-1 * var(--angle)));

    i {
      font-size: 14px;
    }
  }
}
</style>
